import React from 'react';
import classNames from 'classnames';
import cls from './TeamMembersList.module.css';
import { useTeamMembersList } from './useTeamMembersList';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { SortedUser } from '../../../../types/dashboardInformation';
import { NotGivenRow } from '../NotGivenRow/NotGivenRow';
import { useTranslation } from 'react-i18next';

interface TeamMembersListProps {
    classes?: string;
}

enum PARAMS {
    Z_INDEX = 100,
    LEFT_POSITION = 24,
}

export const TeamMembersList = ({ classes }: TeamMembersListProps) => {
    const { sortedUsers, showProjectTeam, can_show_financial_info } = useTeamMembersList();

    const { t } = useTranslation();

    return (
        <>
            {sortedUsers.users.length > 0 ? (
                <div
                    className={classNames(cls.TeamMembersList, [classes])}
                    style={{
                        width: `${
                            (sortedUsers.rest_of_team_count
                                ? sortedUsers.users.length + 1
                                : sortedUsers.users.length) * 24.5
                        }px`,
                    }}
                    onClick={showProjectTeam}
                >
                    <div className={cls.AvatarsWrapper}>
                        {sortedUsers.users.map((user: SortedUser, index: number) => (
                            <React.Fragment key={index}>
                                {user.avatar ? (
                                    <img
                                        className={cls.MemberAvatar}
                                        key={user.id}
                                        src={user.avatar}
                                        alt={user.email}
                                        style={{
                                            zIndex: PARAMS.Z_INDEX + index,
                                            left: `${PARAMS.LEFT_POSITION * index}px`,
                                        }}
                                    />
                                ) : (
                                    <div
                                        className={cls.MemberAvatar}
                                        key={user.id}
                                        style={{
                                            zIndex: PARAMS.Z_INDEX + index,
                                            left: `${PARAMS.LEFT_POSITION * index}px`,
                                        }}
                                    >
                                        <Icon iconName={'profileBigSize'} />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                        {!!sortedUsers.rest_of_team_count && (
                            <div
                                className={cls.TeamCount}
                                style={{
                                    zIndex: PARAMS.Z_INDEX + 5,
                                    left: `${PARAMS.LEFT_POSITION * 5}px`,
                                }}
                            >
                                <span>+{sortedUsers.rest_of_team_count}</span>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                !can_show_financial_info && (
                    <NotGivenRow text={t('TeamMembersList.return.NotGivenRow')} />
                )
            )}
        </>
    );
};
